/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadFacility
 */
export interface PalAuthSubmissionLeadFacility {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadFacility
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadFacility
     */
    name: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadFacility interface.
 */
export function instanceOfPalAuthSubmissionLeadFacility(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PalAuthSubmissionLeadFacilityFromJSON(json: any): PalAuthSubmissionLeadFacility {
    return PalAuthSubmissionLeadFacilityFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PalAuthSubmissionLeadFacilityToJSON(value?: PalAuthSubmissionLeadFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

